/** Shopify CDN: Minification failed

Line 43:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 44:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 45:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 45:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 47:46 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 53:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 57:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 57:23 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 58:12 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 30:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 31:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:46 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 39:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:23 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 44:12 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 19:46 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 25:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:23 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 30:12 Transforming const to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');
    const { $hide, $show } = await importModule('Utils');

    customElements.define('products-counter', class extends Core {
        
        subscriptions = {
            'buyWith:change':  '_updateCounter'
        }

        render() {
            this.subscribe('buyWith:change');
        }
        
        _updateCounter({ selected }) {
            const count = selected + 1;
            if (count > 1) {
                $show(this);
                this.textContent = count;
                return
            } 
            $hide(this); 
        }
    })
})();